import { render, staticRenderFns } from "./PessoaConexaoSelectForm.vue?vue&type=template&id=634e2953"
import script from "./PessoaConexaoSelectForm.vue?vue&type=script&lang=js"
export * from "./PessoaConexaoSelectForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports